import { loadConfig } from '@klausapp/ui-server/config'

const config = loadConfig(({ envString, envBoolean }) => ({
  // General
  gitCommit: envString('GIT_COMMIT', ''),
  devtools: envBoolean('DEVTOOLS', false), // Turn on debugging/profiling mode for app
  flagManager: envBoolean('FLAG_MANAGER', false),
  apiOverride: envString('API_OVERRIDE', ''),
  baseUrl: envString('BASE_URL', ''),
  assetsUrl: envString('ASSETS_URL', '/'),
  lookerDomain: envString('LOOKER_DOMAIN'),
  zendeskDomain: envString('ZENDESK_DOMAIN'),
  embeddedRuntime: false,
  checkA11y: envBoolean('CHECK_A11Y', false),
  domainRoot: envString('DOMAIN_ROOT', ''),
  isAWS: envBoolean('IS_AWS', false),

  // Sentry
  sentryDsn: envString('SENTRY_DSN', ''),
  sentryEnv: envString('SENTRY_ENV', ''),

  // Auth
  authClientId: envString('AUTH_CLIENT_ID', ''),
  authDomain: envString('AUTH_DOMAIN', ''),
  authLogoutUrl: envString('AUTH_LOGOUT_URL', ''),
  authSsoRedirects: envString('AUTH_SSO_REDIRECTS', ''),
  authWhitelistedExtensions: envString('AUTH_WHITELISTED_EXTENSIONS'),

  // Pendo
  pendoIdentifier: envString('PENDO_IDENTIFIER', ''),

  // Integrations
  aircallIdentifier: envString('AIRCALL_IDENTIFIER'),
  helpscoutIdentifier: envString('HELPSCOUT_IDENTIFIER'),
  integrationCallbackUrl: envString('INTEGRATION_CALLBACK_URL'),
  slackId: envString('SLACK_ID'),
  slackCallbackUrl: envString('SLACK_CALLBACK_URL'),
  intercomIdentifier: envString('INTERCOM_IDENTIFIER'),
  salesforceIdentifier: envString('SALESFORCE_IDENTIFIER'),
  zendeskIdentifier: envString('ZENDESK_IDENTIFIER'),
  frontIdentifier: envString('FRONT_IDENTIFIER'),
  gorgiasIdentifier: envString('GORGIAS_IDENTIFIER'),
}))

export default config

export const embeddedRuntime = () => config.embeddedRuntime && !('Cypress' in window)

export const hasZendeskProxy = config.baseUrl === '/qa'
